const rootUrl = 'https://api.github.com'

export { rootUrl }
